import styled, { css } from 'styled-components';
import OnAirIcon from 'images/sports/common/onair_icon.svg';
import BetbleLogo from 'images/sports/common/betble_logo.png';
import ChampLogo from 'images/sports/common/logo_champ.png';

export const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  background: url('../../../../assets/images/sports/soccer/bg_soccer.png')
    no-repeat center center;
  background-size: cover; ;
`;

export const TitleWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const TeamWrapper = styled.div`
  width: 200px;
  min-height: 150px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-items: flex-start;
`;

export const TeamLogo = styled.div`
  width: 70px;
  height: 70px;
`;

export const TeamNameWrapper = styled.div`
  text-align: center;
  width: 100%;
  & > p {
    max-width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    margin-top: 13px;
    font-family: 'GmarketSansMedium', serif;
    font-size: 24px;
    color: #151515;
  }
  & > span {
    font-size: 12px;
    line-height: 20px;
  }
`;
export const Status = styled.div`
  width: 240px;
  height: 125px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

export const MatchStartTime = styled.p`
  text-align: center;
  color: #555;
  line-height: 20px;
`;

export const ButtonWrapper = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 12px;
`;

export const Button = styled.a`
  flex: 1;
  max-width: 85px;
  height: 32px;
  background: #212531;
  border-radius: 5px;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  &:not(:first-child) {
    margin-left: 4px;
  }

  ${(props) =>
    props.champ &&
    css`
      max-width: 65px;
      &:before {
        content: '';
        margin-right: 6px;
        display: inline-block;
        width: 12px;
        height: 12px;
        background: url(${ChampLogo}) no-repeat center center;
        background-size: cover;
      }
    `}
  ${(props) =>
    props.onAir &&
    css`
      &:before {
        content: '';
        margin-right: 6px;
        display: inline-block;
        width: 7px;
        height: 9px;
        background: url(${OnAirIcon}) no-repeat center center;
        background-size: cover;
      }
    `}
  ${(props) =>
    props.betble &&
    css`
      &:before {
        content: '';
        margin-right: 6px;
        display: inline-block;
        width: 8px;
        height: 11px;
        background: url(${BetbleLogo}) no-repeat center center;
        background-size: cover;
      }
    `}
`;
export const CountDown = styled.div`
  width: 100%;
  text-align: center;
  font-family: 'GmarketSansMedium', -apple-system, SF Pro Display,
    Helvetica Neue, Apple SD Gothic Neo, Malgun Gothic,
    '\B9D1\C740   \ACE0\B515', sans-serif;
  font-size: 40px;
  color: #d46104;
  letter-spacing: 2.4px;
`;

export const ScoreWrapper = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const Score = styled.div`
  position: relative;
  flex: 1;
  font-family: Roboto, sans-serif;
  font-size: 50px;
  text-align: center;
  font-weight: 600;
  ${(props) =>
    props.winPosition &&
    css`
      color: #ee1a21;
    `}
`;

export const SetScoreWrapper = styled.div`
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  top: -10px;
  width: 100%;
`;

export const SetScore = styled.span`
  width: 8px;
  height: 8px;
  border-radius: 100%;
  background: #cbcbcb;
  ${(props) =>
    props.isActive &&
    css`
      background: #ed2026;
    `}
`;

export const StateWrapper = styled.div`
  width: 60px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  color: #aaa;
  line-height: 16px;
`;
